export let joinUstitleEN = {
  title1: "Join Us",
  title2: "Explore the Simulation World Together",
};
export let joinUstitleCN = {
  title1: "加入我们",
  title2: "一起探索仿真世界的星辰大海",
};
export let WorkModeEN = {
  title: "Work Values",
  contentArr: [
    "Particularity",
    "Inspiration",
    "Listening",
    "Opportunity",
    "Thoughtfulness",
    "Daringness",
  ],
};
export let WorkModeCN = {
  title: "我们的工作方式",
  contentArr: [
    "Particularity 个性",
    "Inspiration 激励",
    "Listening 倾听",
    "Opportunity 机会",
    "Thoughtfulness 思考",
    "Daringness 勇敢",
  ],
};
export let WelfareEN = {
  title: "Compensation & Benefits",
  contentArr: [
    "Competitive Compensation",
    "Promotion",
    "Flextime",
    "Team Building",
    "Flat Management",
    "Paid Annual Leave",
    "Talent Cultivation",
    "Recreational Benefits",
  ],
};
export let WelfareCN = {
  title: "我们的薪资福利",
  contentArr: [
    "有吸引力的薪资",
    "晋升体系",
    "弹性工作制",
    "团建活动",
    "扁平管理",
    "福利年假",
    "人才培养",
    "文娱福利",
  ],
};
export let jobEN = {
  title: "Open Positions",
  SocietyRecruitment: "Society Recruitment",
  CampusRecruitment: "Campus Recruitment",
  keyword: "Please search by job title",
  JobCategory: "Job Category",
  Tabs: [
    "All",
    "Technical R&D",
    "Product / Project",
    "Strategy / Marketing",
    "Functional Support",
  ],
  collaspAllData: [
    {
      Name: "all",
      left: "UE Engineer",
      right: "Technical R&D | Chongqing",
      label: "技术研发",
      salary: "面议",
      workTitle: "职责描述:",
      workTitleArr: [
        {
          content: "1、负责公司渲染端的开发和维护，研发基于UE4的实时渲染方案；",
        },
        {
          content:
            "2、负责对UE4渲染引擎系统进行扩展，实现新的功能，提升虚拟画面表现；",
        },
        { content: "3、负责UE4与C++开发工程师的联调；" },
        { content: "4、负责基于UE4网络框架的项目业务开发；" },
        { content: "5、优化场景执行效率，渲染效果，物理设置和表现；" },
        {
          content:
            "6、与美术和产品进行良好的沟通，提升项目体验，提高项目品质；",
        },
      ],
      postRequirement: "任职要求：",
      postRequirementArr: [
        { content: "1、计算机相关专业本科及以上学历；" },
        { content: "2、熟悉C/C++，数学或物理基础扎实，逻辑思维能力突出；" },
        {
          content:
            "3、至少2年以上UE4（C++）开发经验，在渲染、物理，性能调优等其中某一领域有丰富经验",
        },
        {
          content:
            "4、扎实的C++基础(数据在内存中的排布方式，宏定义，模板，智能指针，GC等)开发，渲染(渲染性能，特效实现等)、性能优化(GPU，CPU，内存，IO等)、引擎(UBT等)相关(至少在一方面有过一定经验)；",
        },
        {
          content:
            "5、具备良好的编程习惯(清晰的文档及注释)及较强代码规范意识，有高度责任心，能承受较大压力，有较强的自驱力。",
        },
      ],
    },
    {
      Name: "all",
      left: "Image Algorithm Engineer",
      right: "Technical R&D | Shanghai",
      label: "技术研发",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        {
          content:
            "1、协助相关部门对二维数字图像的处理工作，如图像降噪、背景分割、ROI提取等；",
        },
        {
          content:
            "2、根据其他部门对图片的要求或产生的图片或3D场景，逆向生成相机模型；",
        },
        { content: "3、研究或开发相机标定算法、配个其他部门做图像畸变校正；" },
        { content: "4、配合相关部门做相机模型测试与调整；" },
      ],
      postRequirement: "任职要求：",
      postRequirementArr: [
        {
          content:
            "1、本科及以上学历，1-3年工作经验，计算机、光学工程、光学、信号处理等相关专业；",
        },
        {
          content:
            "2、 熟悉相机成像原理和相机成像模型，包括针孔相机模型以及鱼眼相机模型，熟悉常用的相机标定算法；",
        },
        { content: "3、熟悉常用的数字图像处理算法，如滤波，降噪，分割等；" },
        {
          content:
            "4、熟练使用OpenCV、OpenGL、Open3D等相关图像或视觉处理库、以及Halcon等相关图像或视觉处理软件；",
        },
        { content: "5、熟练使用C++/python/Matlab等计算机开发语言。" },
      ],
    },
    {
      Name: "all",
      left: "Point Cloud Algorithm Engineer",
      right: "Technical R&D | Shanghai",
      label: "技术研发",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        { content: "1、负责点云算法的研究与开发工作；" },
        {
          content:
            "2、开发或应用点云相关处理算法完成点云数据的滤波、平滑、分割等工作；",
        },
        {
          content:
            "3、优化3D点云数据，实现离散点云网格化并优化，生成高质量的Mesh；",
        },
        { content: "4、配合其他部门需求，完成点云数据的相关处理工作；" },
        { content: "5、负责相关硬件的安装与调试工作；" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        {
          content:
            "1、本科以上学历，3-5年工作经验，计算机视觉、 光学工程、机械设计、自动化等相关专业；",
        },
        { content: "2、熟练掌握 C/C++/Python 语言,有扎实的编程和算法基础；" },
        {
          content: "3、熟悉激光雷达、毫米波雷达、摄像头、IMU等传感器工作原理；",
        },
        { content: "4、熟悉OpenCV、PCL、CGAL、Eigen、Ceres-solver等开源库；" },
        { content: "5、对3D视觉原理及相关算法熟悉者优先。" },
      ],
    },
    {
      Name: "all",
      left: "Automated Driving Simulation TPL",
      right: "Product/Project |Shanghai",
      label: "产品/项目",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        { content: "1、负责配合售前跟进客户确定需求；" },
        { content: "2、负责定制化产品技术开发计划的制定与跟踪；" },
        { content: "3、负责追踪产品研发质量状态及测试验证状态；" },
        { content: "4、组织研发内部项目例会；" },
        { content: "5、参与项目定期会议并汇报技术开发状态；" },
        { content: "6、支持与客户以及公司其他部门的技术沟通；" },
      ],
      postRequirement: "任职资格：",
      postRequirementArr: [
        {
          content:
            "1、全日制硕士及以上学历，大学英语四级及以上，计算机科学、电子工程、机械工程相关专业；",
        },
        { content: "2、2年以上产品开发管理经验；" },
        {
          content:
            "3、熟悉自动驾驶系统的基本原理和技术，了解仿真和交通流相关内容，具有相关领域的工作经验优先；",
        },
        {
          content:
            "4、熟悉产品开发流程，有较强的技术专业背景，具备技术方案决策能力；",
        },
        { content: "5、熟悉仿真工具和环境，如MATLAB、Simulink、CARLA等；" },
        {
          content:
            "6、具有良好的英语读写能力，能够阅读和编写相关的技术文档和论文；",
        },
        { content: "7、熟悉C++、C#等编程语言及OFFICE办公软件。" },
      ],
    },
    {
      Name: "all",
      left: "Senior U3D Development engineer",
      right: "Technical R&D | Shanghai",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、负责U3D项目开发；" },
        { content: "2、根据需求文档编程实现相应功能" },
        { content: "3、与其他开发工程师及美术人员完成整个项目程序；" },
        { content: "4、Unity3D插件、脚本开发和维护；" },
        {
          content:
            "5、负责新技术的研究与技术积累、关键技术的验证，并能服务于相关业务发展。",
        },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、计算机及相关专业大专以上学历；" },
        {
          content:
            "2、5年以上Unity开发经验, 有完整项目经验，熟悉Unity3D引擎架构；",
        },
        {
          content:
            "3、精通C#/C++，熟悉OOP，有良好的分析和抽象能力，代码风格规范；",
        },
        { content: "4、熟悉UGUI或NGUI，熟悉通用的网络协议；" },
        { content: "5、有整体性能，架构优化经验，熟悉3D图形学和shader编程；" },
        { content: "6、良好的沟通能力和团队精神。" },
      ],
    },
    {
      Name: "all",
      left: "AI Engineer",
      right: "Technical R&D| Shanghai",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、基于Linux和windows系统C++，Python开发；" },
        { content: "2、独立完成模型训练和测试；" },
        { content: "3、独立阅读顶会paper。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、硕士或者博士学历，人工智能相关专业优先；" },
        { content: "2、有3-5年人工智能相关工作经验；" },
        { content: "3、精通Python，C++等编程语言；" },
        { content: "4、熟悉深度学习和CV方向相关算法；" },
        { content: "5、有很好的行业敏锐度和创新能力；" },
        { content: "6、有良好的沟通能力、学习能力以及自我驱动力。" },
      ],
    },
    {
      Name: "all",
      left: "Slam Algorithm Engineer",
      right: "Technical R&D| Shanghai",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、参与车载数据采集系统设计与硬件性能选型；" },
        { content: "2、根据需求实现与优化Slam算法；" },
        { content: "3、数据管理与迭代；" },
        { content: "4、数据处理相关程序开发和维护；" },
        {
          content:
            "5、负责新技术的研究与技术积累、关键技术的验证，并能服务于相关业务发展。",
        },
      ],

      postRequirement: "岗位要求：",
      postRequirementArr: [
        {
          content: "1、测绘技术、车辆工程、计算机技术及相关专业本科以上学历；",
        },
        {
          content:
            "2、3年以上Slam算法开发经验，有完整项目经验，熟悉常用算法实现和数据管理方法；",
        },
        { content: "3、有良好的分析和抽象能力，代码风格规范；" },
        { content: "4、熟悉计算机3D图形学，与三维几何计算知识；" },
        {
          content:
            "5、对自动驾驶感知传感器（例如：毫米波雷达、激光雷达、摄像头）有了解；",
        },
        { content: "6、具有良好的沟通能力和团队精神。" },
      ],
    },
    {
      Name: "all",
      left: "Product Engineer",
      right: "Product/Project | Shanghai",
      label: "产品/项目",
      salary: "面议",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、竞品有关文献、资料收集整理；" },
        { content: "2、竞品分析与评价；" },
        { content: "3、客户需求和内部开发需求的分析、整理和总结；" },
        { content: "4、产品需求规格书的制作。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、统招本科，良好的英语读写能力；" },
        { content: "2、车辆工程等相关专业；" },
        { content: "3、熟练使用office word等办公软件；" },
        { content: "4、对自动驾驶及仿真感兴趣；" },
        {
          content:
            "5、对自动驾驶传感器（摄像头、激光雷达、毫米波雷达、超声波雷达等）有一定的知识背景或有相关项目经验；",
        },
        {
          content:
            "6、细心仔细，注重细节，具有较强的逻辑性，良好的资料收集整理能力。",
        },
      ],
    },
    {
      Name: "all",
      left: "Automated Driving Sales Engineer",
      right: "Strategy/Market | Beijing",
      label: "战略/市场",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、配合公司战略和产品制定行业及区域销售策略；" },
        { content: "2、重点客户的切入、项目推进及资源整合；" },
        { content: "3、全项目周期商务谈判、风控及内部项目及团队的协同；" },
        { content: "4、需求导入、产品定义、竞品及行业分析。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、自动驾驶行业销售或技术支持三年以上经验；" },
        {
          content:
            "2、熟悉传统tier1、各种传感器供应商，有重要客户商务经验者优先；",
        },
        { content: "3、熟悉汽车辅助驾驶、自动驾驶的方案及上下游产业链；" },
        { content: "4、熟悉行业竞品，熟悉人工智能基本产品者优先；" },
        {
          content:
            "5、为人诚实正直、工作严谨、有责任心、善于沟通、抗压能力强； ",
        },
      ],
    },
  ],
  schoolAllData: [
    {
      Name: "Product",
      left: "Product engineer",
      right: "Product/Project | Shanghai",
      label: "产品/项目",
      salary: "硕士250元/天，本科150元/天",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、竞品有关文献、资料收集整理；" },
        { content: "2、竞品分析与评价；" },
        { content: "3、客户需求和内部开发需求的分析、整理和总结；" },
        { content: "4、产品需求规格书的制作。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、统招本科，良好的英语读写能力；" },
        { content: "2、车辆工程等相关专业；" },
        { content: "3、熟练使用office word等办公软件；" },
        { content: "4、对自动驾驶及仿真感兴趣；" },
        {
          content:
            "5、对自动驾驶传感器（摄像头、激光雷达、毫米波雷达、超声波雷达等）有一定的知识背景或有相关项目经验；",
        },
        {
          content:
            "6、细心仔细，注重细节，具有较强的逻辑性，良好的资料收集整理能力。",
        },
      ],
    },
    {
      Name: "Product",
      left: "Project assistant (Management Tainee)",
      right: "Product/Project | Shanghai",
      label: "产品/项目",
      salary: "硕士250元/天，本科150元/天",
      workTitle: "工作内容：",
      workTitleArr: [
        {
          content:
            "1. 协助项目经理负责研发团队迭代与项目资源协调与组织，确保项目各干系人协同工作；",
        },
        {
          content:
            "2. 协助项目经理跟踪项目进度与里程碑完成情况、合理安排人员排期，监控风险、协调解决问题；",
        },
        { content: "3. 及时对项目中出现的各类问题进行沟通、跟进与汇报；" },
        {
          content:
            "4. 协助项目经理进行项目规范与流程模板的制定，跟踪及监控各项目规范执行情况；",
        },
        { content: "5. 协助项目经理进行项目项目计划和变更记录更新；" },
        { content: "6. 多项目并行管理和追踪，项目数据的收集、整合和分析；" },
        { content: "7. 其他临时工作：按时完成上级交代的其他临时任务。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1. 软件工程等相关大学本科或以上学历；" },
        { content: "2. 做事认真仔细，具有较强的原则性和责任心；" },
        { content: "3. 有较好语言表达能力，愿意沟通，有良好的团队精神；" },
        {
          content:
            "4. 对细节的强烈关注，善于思考，思维清晰敏捷，逻辑分析能力强，有很强的时间观念和较高的任务执行力；",
        },
        { content: "5. 学习能力强，愿意学习，能快速适应不断变化环境和挑战；" },
        {
          content:
            "6. 有项目管理经验，熟悉项目管理工作流程，熟悉使用禅道、jira等项目管理软件优先。",
        },
      ],
    },
  ],
  contact:
    "Welcome to send your resume to contact@pd-automotive.com. We will give you reply within one business day.",
  cooperation: "For School-enterprise, Please Call: 021-69585189",
};
export let jobCN = {
  title: "我们在招职位",
  SocietyRecruitment: "社会招聘",
  CampusRecruitment: "校园招聘",
  keyword: "请输入搜索名称",
  JobCategory: "职位类别",
  Tabs: ["全部", "技术研发", "产品/项目", "战略/市场", "职能支持"],
  collaspAllData: [
    {
      Name: "all",
      left: "UE工程师",
      right: "技术研发 | 重庆",
      label: "技术研发",
      salary: "面议",
      workTitle: "职责描述:",
      workTitleArr: [
        {
          content: "1、负责公司渲染端的开发和维护，研发基于UE4的实时渲染方案；",
        },
        {
          content:
            "2、负责对UE4渲染引擎系统进行扩展，实现新的功能，提升虚拟画面表现；",
        },
        { content: "3、负责UE4与C++开发工程师的联调；" },
        { content: "4、负责基于UE4网络框架的项目业务开发；" },
        { content: "5、优化场景执行效率，渲染效果，物理设置和表现；" },
        {
          content:
            "6、与美术和产品进行良好的沟通，提升项目体验，提高项目品质；",
        },
      ],
      postRequirement: "任职要求：",
      postRequirementArr: [
        { content: "1、计算机相关专业本科及以上学历；" },
        { content: "2、熟悉C/C++，数学或物理基础扎实，逻辑思维能力突出；" },
        {
          content:
            "3、至少2年以上UE4（C++）开发经验，在渲染、物理，性能调优等其中某一领域有丰富经验",
        },
        {
          content:
            "4、扎实的C++基础(数据在内存中的排布方式，宏定义，模板，智能指针，GC等)开发，渲染(渲染性能，特效实现等)、性能优化(GPU，CPU，内存，IO等)、引擎(UBT等)相关(至少在一方面有过一定经验)；",
        },
        {
          content:
            "5、具备良好的编程习惯(清晰的文档及注释)及较强代码规范意识，有高度责任心，能承受较大压力，有较强的自驱力。",
        },
      ],
    },
    {
      Name: "all",
      left: "图像算法处理工程师",
      right: "技术研发 | 上海",
      label: "技术研发",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        {
          content:
            "1、协助相关部门对二维数字图像的处理工作，如图像降噪、背景分割、ROI提取等；",
        },
        {
          content:
            "2、根据其他部门对图片的要求或产生的图片或3D场景，逆向生成相机模型；",
        },
        { content: "3、研究或开发相机标定算法、配个其他部门做图像畸变校正；" },
        { content: "4、配合相关部门做相机模型测试与调整；" },
      ],
      postRequirement: "任职要求：",
      postRequirementArr: [
        {
          content:
            "1、本科及以上学历，1-3年工作经验，计算机、光学工程、光学、信号处理等相关专业；",
        },
        {
          content:
            "2、 熟悉相机成像原理和相机成像模型，包括针孔相机模型以及鱼眼相机模型，熟悉常用的相机标定算法；",
        },
        { content: "3、熟悉常用的数字图像处理算法，如滤波，降噪，分割等；" },
        {
          content:
            "4、熟练使用OpenCV、OpenGL、Open3D等相关图像或视觉处理库、以及Halcon等相关图像或视觉处理软件；",
        },
        { content: "5、熟练使用C++/python/Matlab等计算机开发语言。" },
      ],
    },
    {
      Name: "all",
      left: "点云算法工程师",
      right: "技术研发 | 上海",
      label: "技术研发",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        { content: "1、负责点云算法的研究与开发工作；" },
        {
          content:
            "2、开发或应用点云相关处理算法完成点云数据的滤波、平滑、分割等工作；",
        },
        {
          content:
            "3、优化3D点云数据，实现离散点云网格化并优化，生成高质量的Mesh；",
        },
        { content: "4、配合其他部门需求，完成点云数据的相关处理工作；" },
        { content: "5、负责相关硬件的安装与调试工作；" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        {
          content:
            "1、本科以上学历，3-5年工作经验，计算机视觉、 光学工程、机械设计、自动化等相关专业；",
        },
        { content: "2、熟练掌握 C/C++/Python 语言,有扎实的编程和算法基础；" },
        {
          content: "3、熟悉激光雷达、毫米波雷达、摄像头、IMU等传感器工作原理；",
        },
        { content: "4、熟悉OpenCV、PCL、CGAL、Eigen、Ceres-solver等开源库；" },
        { content: "5、对3D视觉原理及相关算法熟悉者优先。" },
      ],
    },
    {
      Name: "all",
      left: "自动驾驶仿真TPL",
      right: "产品/项目 | 上海",
      label: "产品/项目",
      salary: "面议",
      workTitle: "岗位职责:",
      workTitleArr: [
        { content: "1、负责配合售前跟进客户确定需求；" },
        { content: "2、负责定制化产品技术开发计划的制定与跟踪；" },
        { content: "3、负责追踪产品研发质量状态及测试验证状态；" },
        { content: "4、组织研发内部项目例会；" },
        { content: "5、参与项目定期会议并汇报技术开发状态；" },
        { content: "6、支持与客户以及公司其他部门的技术沟通；" },
      ],
      postRequirement: "任职资格：",
      postRequirementArr: [
        {
          content:
            "1、全日制硕士及以上学历，大学英语四级及以上，计算机科学、电子工程、机械工程相关专业；",
        },
        { content: "2、2年以上产品开发管理经验；" },
        {
          content:
            "3、熟悉自动驾驶系统的基本原理和技术，了解仿真和交通流相关内容，具有相关领域的工作经验优先；",
        },
        {
          content:
            "4、熟悉产品开发流程，有较强的技术专业背景，具备技术方案决策能力；",
        },
        { content: "5、熟悉仿真工具和环境，如MATLAB、Simulink、CARLA等；" },
        {
          content:
            "6、具有良好的英语读写能力，能够阅读和编写相关的技术文档和论文；",
        },
        { content: "7、熟悉C++、C#等编程语言及OFFICE办公软件。" },
      ],
    },
    {
      Name: "all",
      left: "资深U3D开发工程师",
      right: "技术研发 | 上海",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、负责U3D项目开发；" },
        { content: "2、根据需求文档编程实现相应功能" },
        { content: "3、与其他开发工程师及美术人员完成整个项目程序；" },
        { content: "4、Unity3D插件、脚本开发和维护；" },
        {
          content:
            "5、负责新技术的研究与技术积累、关键技术的验证，并能服务于相关业务发展。",
        },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、计算机及相关专业大专以上学历；" },
        {
          content:
            "2、5年以上Unity开发经验, 有完整项目经验，熟悉Unity3D引擎架构；",
        },
        {
          content:
            "3、精通C#/C++，熟悉OOP，有良好的分析和抽象能力，代码风格规范；",
        },
        { content: "4、熟悉UGUI或NGUI，熟悉通用的网络协议；" },
        { content: "5、有整体性能，架构优化经验，熟悉3D图形学和shader编程；" },
        { content: "6、良好的沟通能力和团队精神。" },
      ],
    },
    {
      Name: "all",
      left: "AI工程师",
      right: "技术研发 | 上海",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、基于Linux和windows系统C++，Python开发；" },
        { content: "2、独立完成模型训练和测试；" },
        { content: "3、独立阅读顶会paper。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、硕士或者博士学历，人工智能相关专业优先；" },
        { content: "2、有3-5年人工智能相关工作经验；" },
        { content: "3、精通Python，C++等编程语言；" },
        { content: "4、熟悉深度学习和CV方向相关算法；" },
        { content: "5、有很好的行业敏锐度和创新能力；" },
        { content: "6、有良好的沟通能力、学习能力以及自我驱动力。" },
      ],
    },
    {
      Name: "all",
      left: "slam算法工程师",
      right: "技术研发 | 上海",
      label: "技术研发",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、参与车载数据采集系统设计与硬件性能选型；" },
        { content: "2、根据需求实现与优化Slam算法；" },
        { content: "3、数据管理与迭代；" },
        { content: "4、数据处理相关程序开发和维护；" },
        {
          content:
            "5、负责新技术的研究与技术积累、关键技术的验证，并能服务于相关业务发展。",
        },
      ],

      postRequirement: "岗位要求：",
      postRequirementArr: [
        {
          content: "1、测绘技术、车辆工程、计算机技术及相关专业本科以上学历；",
        },
        {
          content:
            "2、3年以上Slam算法开发经验，有完整项目经验，熟悉常用算法实现和数据管理方法；",
        },
        { content: "3、有良好的分析和抽象能力，代码风格规范；" },
        { content: "4、熟悉计算机3D图形学，与三维几何计算知识；" },
        {
          content:
            "5、对自动驾驶感知传感器（例如：毫米波雷达、激光雷达、摄像头）有了解；",
        },
        { content: "6、具有良好的沟通能力和团队精神。" },
      ],
    },
    {
      Name: "all",
      left: "产品工程师",
      right: "产品/项目 | 上海",
      label: "产品/项目",
      salary: "面议",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、竞品有关文献、资料收集整理；" },
        { content: "2、竞品分析与评价；" },
        { content: "3、客户需求和内部开发需求的分析、整理和总结；" },
        { content: "4、产品需求规格书的制作。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、统招本科，良好的英语读写能力；" },
        { content: "2、车辆工程等相关专业；" },
        { content: "3、熟练使用office word等办公软件；" },
        { content: "4、对自动驾驶及仿真感兴趣；" },
        {
          content:
            "5、对自动驾驶传感器（摄像头、激光雷达、毫米波雷达、超声波雷达等）有一定的知识背景或有相关项目经验；",
        },
        {
          content:
            "6、细心仔细，注重细节，具有较强的逻辑性，良好的资料收集整理能力。",
        },
      ],
    },
    {
      Name: "all",
      left: "自动驾驶销售工程师",
      right: "战略/市场 | 北京",
      label: "战略/市场",
      salary: "面议",
      workTitle: "工作内容：",
      workTitleArr: [
        { content: "1、配合公司战略和产品制定行业及区域销售策略；" },
        { content: "2、重点客户的切入、项目推进及资源整合；" },
        { content: "3、全项目周期商务谈判、风控及内部项目及团队的协同；" },
        { content: "4、需求导入、产品定义、竞品及行业分析。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、自动驾驶行业销售或技术支持三年以上经验；" },
        {
          content:
            "2、熟悉传统tier1、各种传感器供应商，有重要客户商务经验者优先；",
        },
        { content: "3、熟悉汽车辅助驾驶、自动驾驶的方案及上下游产业链；" },
        { content: "4、熟悉行业竞品，熟悉人工智能基本产品者优先；" },
        {
          content:
            "5、为人诚实正直、工作严谨、有责任心、善于沟通、抗压能力强； ",
        },
      ],
    },
  ],
  schoolAllData: [
    {
      Name: "Product",
      left: "产品工程师",
      right: "产品/项目 | 上海",
      label: "产品/项目",
      salary: "硕士250元/天，本科150元/天",
      workTitle: "工作内容:",
      workTitleArr: [
        { content: "1、竞品有关文献、资料收集整理；" },
        { content: "2、竞品分析与评价；" },
        { content: "3、客户需求和内部开发需求的分析、整理和总结；" },
        { content: "4、产品需求规格书的制作。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1、统招本科，良好的英语读写能力；" },
        { content: "2、车辆工程等相关专业；" },
        { content: "3、熟练使用office word等办公软件；" },
        { content: "4、对自动驾驶及仿真感兴趣；" },
        {
          content:
            "5、对自动驾驶传感器（摄像头、激光雷达、毫米波雷达、超声波雷达等）有一定的知识背景或有相关项目经验；",
        },
        {
          content:
            "6、细心仔细，注重细节，具有较强的逻辑性，良好的资料收集整理能力。",
        },
      ],
    },
    {
      Name: "Product",
      left: "项目助理（管培岗）",
      right: "产品/项目 | 上海",
      label: "产品/项目",
      salary: "硕士250元/天，本科150元/天",
      workTitle: "工作内容：",
      workTitleArr: [
        {
          content:
            "1. 协助项目经理负责研发团队迭代与项目资源协调与组织，确保项目各干系人协同工作；",
        },
        {
          content:
            "2. 协助项目经理跟踪项目进度与里程碑完成情况、合理安排人员排期，监控风险、协调解决问题；",
        },
        { content: "3. 及时对项目中出现的各类问题进行沟通、跟进与汇报；" },
        {
          content:
            "4. 协助项目经理进行项目规范与流程模板的制定，跟踪及监控各项目规范执行情况；",
        },
        { content: "5. 协助项目经理进行项目项目计划和变更记录更新；" },
        { content: "6. 多项目并行管理和追踪，项目数据的收集、整合和分析；" },
        { content: "7. 其他临时工作：按时完成上级交代的其他临时任务。" },
      ],
      postRequirement: "岗位要求：",
      postRequirementArr: [
        { content: "1. 软件工程等相关大学本科或以上学历；" },
        { content: "2. 做事认真仔细，具有较强的原则性和责任心；" },
        { content: "3. 有较好语言表达能力，愿意沟通，有良好的团队精神；" },
        {
          content:
            "4. 对细节的强烈关注，善于思考，思维清晰敏捷，逻辑分析能力强，有很强的时间观念和较高的任务执行力；",
        },
        { content: "5. 学习能力强，愿意学习，能快速适应不断变化环境和挑战；" },
        {
          content:
            "6. 有项目管理经验，熟悉项目管理工作流程，熟悉使用禅道、jira等项目管理软件优先。",
        },
      ],
    },
  ],
  contact: "欢迎投递简历至 hr@pd-automotive.com，我们将在1个工作日内给您答复。",
  cooperation: "校企合作请致电：021-69585189",
};
